import { render, staticRenderFns } from "./sourcingmaster.vue?vue&type=template&id=42ba247a&scoped=true"
import script from "./sourcingmaster.vue?vue&type=script&lang=js"
export * from "./sourcingmaster.vue?vue&type=script&lang=js"
import style0 from "./sourcingmaster.vue?vue&type=style&index=0&id=42ba247a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba247a",
  null
  
)

export default component.exports